"use strict";

exports.__esModule = true;
exports.AddPartCountUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _AddPartCountActionElement = require("./AddPartCountActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AddPartCountUserAction = exports.AddPartCountUserAction = {
  name: "AddPartCount",
  icon: "add",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AddPartCountUserActionDefinition.label",
    defaultMessage: "Add Part Count"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AddPartCountUserActionDefinition.description",
    defaultMessage: "Add the part count of a particular part kind"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _AddPartCountActionElement.AddPartCountActionElement
  }
};